<app-page-header
  class="header"
  [backSwipe]="backSwipeConfig"
  [backButtonRouterLink]="['/main', 'home']"
/>

<div class="content">
  <div class="top">
    <span class="big">Book a table</span>
    <span class="top__text">Enjoy an elevated and exclusive experience<br>with an upscale menu and a new atmosphere. RS is a unique take on the traditional sports bar.</span>
  </div>

  <div class="qr__box">
    <div class="description">
      <span class="label">Small groups</span>
      <span class="text">For groups of 12 or under, book a table and join us in Real Sports for lunch, dinner or drinks.</span>
      <span class="sublabel">Bookings can be made up to 3 weeks in advance.</span>
    </div>

    <div class="qr__wrapper">
      <app-qrcode content="https://oon.gl/L2zAWV" [size]="160"/>
      <span class="label">BOOK NOW</span>
    </div>
  </div>

  <div class="qr__box">
    <div class="description">
      <span class="label">LARGE GROUPS + PRIVATE EVENTS</span>
      <span class="text">For private events or groups of 13 or more, please contact us directly.</span>
    </div>

    <div class="qr__wrapper">
      <app-qrcode content="https://oon.gl/PXnWeS" [size]="160"/>
      <span class="label">Submit Inquiry</span>
    </div>
  </div>



</div>
